"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var Config = /** @class */ (function () {
    function Config(data) {
        this.var = data.var;
        this.config = data.config;
    }
    return Config;
}());
exports.Config = Config;
;
//# sourceMappingURL=Configs.js.map